export class FetchLocation {
  public static readonly type = '[Geolocation] Fetch location';
}
